const rotulosTabela: Record<string, string> = {
  atuacao: 'atuação',
  comarca: 'comarca',
  configuracoes: 'configuração',
  conselho_superior: 'conselho superior',
  curso: 'curso',
  defensor: 'defensor',
  defensoria: 'defensoria',
  distrito: 'distrito',
  diretoria: 'diretoria',
  endereco: 'endereço',
  estagiario: 'estagiário',
  estagiario_anexo: 'anexo de estagiário',
  estagio: 'estágio',
  feriado: 'feriado',
  funcao: 'função',
  funcao_salario: 'salário da função',
  historico: 'histórico',
  instituicao_ensino: 'instituição de ensino',
  lotacao: 'lotação',
  movimentacao: 'atividade',
  movimentacao_registro: 'registro de atividade',
  movimentacaoregistro: 'registro de atividade',
  movimentacao_tipo: 'tipo de movimentação',
  movimentacaotipo: 'tipo de movimentação',
  notificacao: 'notificação',
  nucleo: 'núcleo',
  periodo: 'ação',
  pessoa: 'pessoa',
  tipo_gasto: 'tipo de gasto',
  gasto: 'gasto',
  predio: 'prédio',
  regra: 'regra',
  responsavel: 'responsável',
  setor: 'setor',
  substituicao: 'substituição',
  telefone: 'telefone',
  usuario: 'usuário',
  vara: 'vara',
};

const camposOcultos = new Set([
  'senha',
  'password',
  'codigorecuperacao',
  'criadoem',
  'editadoem',
  'criadopor',
  'editadopor',
  'id',
]);

export function rotuloAcao(acao: string): string {
  if (acao === 'INSERT') return 'Inclusão';
  if (acao === 'UPDATE') return 'Atualização';
  if (acao === 'DELETE') return 'Exclusão';
  return acao;
}

export function rotuloTabela(tabela: string): string {
  const nome = rotulosTabela[tabela] ?? tabela.replaceAll('_', ' ');
  return nome.charAt(0).toUpperCase() + nome.slice(1);
}

export function rotuloAcaoTabela(acao: string, tabela: string): string {
  return `${rotuloAcao(acao)} ${rotuloTabela(tabela).toLowerCase()}`;
}

export function chavesDiffVisiveis(diff: Record<string, unknown> | null | undefined): string[] {
  if (!diff) return [];
  return Object.keys(diff).filter((campo) => !campoOculto(campo));
}

function campoOculto(campo: string): boolean {
  const normalizado = campo.toLowerCase();
  return camposOcultos.has(normalizado) || normalizado.endsWith('_hash');
}

function campoSenha(campo: string): boolean {
  const normalizado = campo.toLowerCase();
  return normalizado === 'senha' || normalizado === 'password';
}

const camposAuditoria = new Set([
  'ultimo_login',
  'editadoem',
  'editadopor',
  'criadoem',
  'criadopor',
  'id',
]);

function campoSecreto(campo: string): boolean {
  const normalizado = campo.toLowerCase();
  return normalizado === 'codigorecuperacao' || normalizado.endsWith('_hash');
}

export function ehAlteracaoSomenteAuditoria(diff: unknown): boolean {
  if (!diff || typeof diff !== 'object' || Array.isArray(diff)) return false;
  const chaves = Object.keys(diff);
  if (chaves.length === 0) return false;
  return chaves.every((campo) => camposAuditoria.has(campo.toLowerCase()));
}

function valorGravado(valor: unknown): unknown {
  if (valor == null || typeof valor !== 'object' || Array.isArray(valor)) return valor ?? null;
  const chaves = Object.keys(valor);
  if (chaves.length === 0 || chaves.some((chave) => chave !== 'antes' && chave !== 'depois')) return valor;
  return (valor as { depois?: unknown }).depois ?? null;
}

export function jsonDetalheHistorico(diff: Record<string, unknown> | null | undefined): string | null {
  if (!diff) return null;

  const objeto: Record<string, unknown> = {};
  for (const [campo, valor] of Object.entries(diff)) {
    if (campoSenha(campo)) {
      objeto.senha = 'alterada';
      continue;
    }
    if (campoSecreto(campo)) {
      objeto[campo] = 'alterado';
      continue;
    }
    objeto[campo] = valorGravado(valor);
  }

  if (Object.keys(objeto).length === 0) return null;
  return JSON.stringify(objeto, null, 2);
}
